export class GlobalVariables {
    public static appURL: string = "https://api.stage.scanfluence.com/";
    public static couponShareURL: string = "https://share.onoffer.live/";
  }
  